module.exports = __webpack_public_path__ + "img/reward-2.0231eeb5.png";